<div class="modal fade" tabindex="-1" role="dialog" id="objetivo-venda-filtro">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 translate class="modal-title">{{'parametros.objetivoVenda.filtros.definirFiltros'}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container striped-rows">
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.objetivoVenda.filtros.dealer'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="text"
                placeholder="{{'parametros.objetivoVenda.filtros.dealerPlaceHolder' | translate}}"
                [(ngModel)]="filtros.descricao">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.objetivoVenda.filtros.ano'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number"
                placeholder="{{'parametros.objetivoVenda.filtros.anoPlaceHolder' | translate}}"
                [(ngModel)]="filtros.ano">
            </div>
          </div>
          <div class="row ptb5">
            <div translate class="col col-4">
              {{'parametros.objetivoVenda.filtros.mes'}}
            </div>
            <div class="col col-8">
              <input class="form-control form-control-sm" type="number"
                placeholder="{{'parametros.objetivoVenda.filtros.mesPlaceHolder' | translate}}"
                [(ngModel)]="filtros.meses">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary"
          (click)="filtros.id = '' || filtros.nome_dealer = '' || filtros.ano = '' || filtros.meses = ''">
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-info" data-dismiss="modal">OK</button>
      </div>
    </div>
  </div>
</div>